import { useContext } from 'react';
import { __RouterContext, RouteComponentProps } from 'react-router';

export function useRouter<T extends Record<string, string>>() {
  return useContext(__RouterContext) as RouteComponentProps<T>;
}
